import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  orderRiderDispatchAssignOrders,
  orderRiderDispatchAssignOrdersVariables
} from "./types/orderRiderDispatchAssignOrders";
import {
  orderRiderDispatchSearchAndValidation,
  orderRiderDispatchSearchAndValidationVariables
} from "./types/orderRiderDispatchSearchAndValidation";

const orderRiderDispatchSearchAndValidationMutation = gql`
  mutation orderRiderDispatchSearchAndValidation(
    $orderCodes: [String]!
    $riderId: ID!
  ) {
    orderRiderDispatchSearchAndValidation(
      orderCodes: $orderCodes
      riderId: $riderId
    ) {
      hasErrors
      orders {
        id
        orderCode
        user {
          id
          email
          firstName
          lastName
          contactNo
        }
        shippingAddress {
          id
          streetAddress1
          streetAddress2
          postalCode
          city
          cityArea
          streetBrgy
          unitDetails
          landmark
        }
        shippingSchedule
      }
      ordersWithError
      orderErrors {
        field
        message
        code
      }
    }
  }
`;

export const useValidateOrder = makeMutation<
  orderRiderDispatchSearchAndValidation,
  orderRiderDispatchSearchAndValidationVariables
>(orderRiderDispatchSearchAndValidationMutation);

const orderRiderDispatchAssignOrdersMutation = gql`
  mutation orderRiderDispatchAssignOrders($orderIds: [String]!, $riderId: ID!) {
    orderRiderDispatchAssignOrders(orderIds: $orderIds, riderId: $riderId) {
      hasErrors
      orders {
        id
        orderCode
        user {
          id
          email
          firstName
          lastName
          contactNo
        }
        shippingAddress {
          id
          streetAddress1
          streetAddress2
          postalCode
          city
          cityArea
          streetBrgy
          unitDetails
          landmark
        }
        shippingSchedule
      }
      ordersWithError
      orderErrors {
        field
        message
        code
      }
    }
  }
`;

export const useDispatchAssignRider = makeMutation<
  orderRiderDispatchAssignOrders,
  orderRiderDispatchAssignOrdersVariables
>(orderRiderDispatchAssignOrdersMutation);
